import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Container } from "reactstrap";
import { Link } from "@reach/router";

class SelectionNotice extends Component {
  state = {};

  render() {
    const { selectedOperators, handleRemoveSelectAll } = this.props;
    return (
      <>
        <Row className="notice__row  mb-4 px-4 d-flex" noGutters>
          <Container>
            <Row>
              <Col className="notice___col-1 ml-3 mt-3">
                <h5 className="header_title4 c_btn">
                  {selectedOperators.length} operators selected
                </h5>

                <h5 className="">
                  {" "}
                  <div
                    className=" header_title5 c_btn"
                    onClick={handleRemoveSelectAll}
                  >
                    Remove Selected Operators
                  </div>
                </h5>
              </Col>
              <Col className="d-flex justify-content-end mr-3">
                <div className="c_btn success_btn_ mt-2">
                  <Link to="/ticket-details">Continue</Link>
                </div>
                {/*<Button size="sm" className="m-2" onClick={handleCloseNotice}>*/}
                {/*Close*/}
                {/*</Button>*/}
              </Col>
            </Row>
          </Container>
        </Row>
      </>
    );
  }
}

SelectionNotice.propTypes = {
  numberOfOperators: PropTypes.number,
  handleCloseNotice: PropTypes.func,
  handleSelectAll: PropTypes.func,
};

export default SelectionNotice;
